import { useCallback } from 'react'
import conf from '~/app/conf'
import { getYaNative } from '@yanolja-rnd/ya-native'
import { isNative } from '~/app/utils/typeguards'

/**
 * useGoHome
 * author: soojin.oh
 */

// type definitions

// hook
const useGoHome = function () {
  const goHome = useCallback(() => {
    const yaNative = getYaNative()
    if (isNative(yaNative)) {
      yaNative.deepLink({ link: conf.app.home.url })
    } else {
      window.location.href = conf.web.url
    }
  }, [])

  return {
    goHome,
  }
}

export default useGoHome
